import mapFunction from './mapResources';

export default mapFunction('my_operations', {
    isFetching: false,
    items: [] 
});
